import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, isValidElement } from 'react';
import { Icon } from '..';
import { Popover } from '../Popover';
import { OptionItem } from '../OptionItem';
import { Typography } from '../Typography';
import * as S from './styles';

var FloatButton = function FloatButton(_ref) {
  var actions = _ref.actions,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'regular' : _ref$variant,
      _ref$hasDivider = _ref.hasDivider,
      hasDivider = _ref$hasDivider === void 0 ? true : _ref$hasDivider;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPopover = _useState2[0],
      setShowPopover = _useState2[1];

  var closePopover = function closePopover() {
    return setShowPopover(false);
  };

  var togglePopover = function togglePopover() {
    return setShowPopover(function (prevState) {
      return !prevState;
    });
  };

  function _handleClick(actionClick) {
    actionClick();
    closePopover();
  }

  return React.createElement(Popover, {
    visible: showPopover,
    onClickOutside: closePopover,
    content: React.createElement(S.OptionsContainer, {
      variant: variant
    }, actions.map(function (action, index) {
      return React.createElement(OptionItem, {
        hasDivider: hasDivider ? actions.length > 1 : false,
        key: index,
        handleClick: function handleClick() {
          return _handleClick(action.onClick);
        },
        size: variant
      }, isValidElement(action.label) ? action.label : React.createElement(Typography, {
        variant: 'content2'
      }, action.label));
    }))
  }, React.createElement(S.Button, {
    onClick: togglePopover
  }, React.createElement(Icon, {
    name: 'OptionsHorizontal',
    height: 24,
    width: 24
  })));
};

export { FloatButton };